import { staffListSelect } from "@/utils/api";
export const publicMethod = {
    data() {
        return {
            dataSource: [{
                serialNum: 1,
                productName: "商品1",
                code: "aaa123456",
                voucherDate: "2020-3-23",
                transactorName: "张三",
                totalAmount: "20.00",
                shouhuoren: "莉丝",
                fahuomendian: "萧山门店",
                shuliang: 120,
                beizhu: "",
                status: 1,
                operation: ""
            }, {
                serialNum: 1,
                productName: "商品1",
                code: "aaa123456",
                voucherDate: "2020-3-23",
                transactorName: "张三",
                totalAmount: "20.00",
                shouhuoren: "莉丝",
                fahuomendian: "萧山门店",
                shuliang: 120,
                beizhu: "",
                status: 2,
                operation: ""
            }, {
                serialNum: 1,
                productName: "商品1",
                code: "aaa123456",
                voucherDate: "2020-3-23",
                transactorName: "张三",
                totalAmount: "20.00",
                shouhuoren: "莉丝",
                fahuomendian: "萧山门店",
                shuliang: 120,
                beizhu: "",
                status: 3,
                operation: ""
            }, {
                serialNum: 1,
                productName: "商品1",
                code: "aaa123456",
                voucherDate: "2020-3-23",
                transactorName: "张三",
                totalAmount: "20.00",
                shouhuoren: "莉丝",
                fahuomendian: "萧山门店",
                shuliang: 330,
                beizhu: "",
                status: 4,
                operation: ""
            }, {
                serialNum: 1,
                productName: "商品12222",
                code: "aaa123456",
                voucherDate: "2020-3-23",
                transactorName: "里斯",
                totalAmount: "20.00",
                shouhuoren: "卡收",
                fahuomendian: "萧山门店",
                shuliang: 1230,
                beizhu: "",
                status: 5,
                operation: ""
            }, {
                serialNum: 1,
                productName: "商品商品商品",
                code: "aaa123456",
                voucherDate: "2020-3-23",
                transactorName: "张三",
                totalAmount: "203.00",
                shouhuoren: "丽萨",
                fahuomendian: "萧山门店",
                shuliang: 1200,
                beizhu: "",
                status: 6,
                operation: ""
            }],
            ipagination: {
                current: 1,
                pageSize: 10,
                showTotal: (total, range) => {
                    return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 100
            },
            contentHeight: '',
            tableHeight: ''
        }
    },
    methods: {
        // 获取经办人列表
        getStaffListSelect() {
            let params = new FormData();
            params.append(
                "companyStoreId",
                this.$store.state.userInfo.companyStoreId
            );
            staffListSelect(params).then((res) => {
                if (res.code == 200) {
                    this.agentList = res.result;
                } else {
                    this.$message.error(res.logMessage);
                }
            });
        },
        // 选择经办人
        selectAgent(e) {
            this.formData.transactorId = this.agentList[e].id;
            this.formData.transactorName = this.agentList[e].name;
        },
    }
}